
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2051"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2051"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1oFqu", function(module, exports) {

$parcel$export(module.exports, "encodeUrlPayload", function () { return $08a0126f35029825$export$8d0f35cd8ab2231e; });
$parcel$export(module.exports, "decodeUrlPayload", function () { return $08a0126f35029825$export$d269922819925891; });
// https://github.com/crabbo-rave/CompressedBF
const $08a0126f35029825$var$charRange = [
    [
        32,
        126
    ],
    [
        160,
        255
    ],
    [
        256,
        383
    ],
    [
        384,
        591
    ],
    [
        592,
        687
    ],
    [
        688,
        767
    ],
    [
        880,
        1023
    ],
    [
        1024,
        1279
    ],
    [
        1280,
        1327
    ],
    [
        1328,
        1423
    ],
    [
        1424,
        1535
    ],
    [
        1536,
        1791
    ],
    [
        1792,
        1871
    ],
    [
        1920,
        1983
    ],
    [
        2304,
        2431
    ],
    [
        2432,
        2559
    ],
    [
        2560,
        2687
    ],
    [
        2688,
        2815
    ],
    [
        2816,
        2943
    ],
    [
        2944,
        3071
    ],
    [
        3072,
        3199
    ],
    [
        3200,
        3327
    ],
    [
        3328,
        3455
    ],
    [
        3456,
        3583
    ],
    [
        3584,
        3711
    ],
    [
        3712,
        3839
    ],
    [
        3840,
        4095
    ],
    [
        4096,
        4255
    ],
    [
        4256,
        4351
    ],
    [
        4352,
        4607
    ],
    [
        4608,
        4991
    ],
    [
        5024,
        5119
    ],
    [
        5120,
        5759
    ],
    [
        5760,
        5791
    ],
    [
        5792,
        5887
    ],
    [
        5888,
        5919
    ],
    [
        5920,
        5951
    ],
    [
        5952,
        5983
    ],
    [
        5984,
        6015
    ],
    [
        6016,
        6143
    ],
    [
        6144,
        6319
    ],
    [
        7680,
        7935
    ],
    [
        7936,
        8191
    ],
    [
        8192,
        8303
    ],
    [
        8352,
        8399
    ],
    [
        8448,
        8527
    ],
    [
        8528,
        8591
    ],
    [
        8592,
        8703
    ],
    [
        8704,
        8959
    ],
    [
        9472,
        9599
    ],
    [
        9600,
        9631
    ],
    [
        9632,
        9727
    ],
    [
        9728,
        9983
    ],
    [
        9984,
        10175
    ],
    [
        12352,
        12447
    ],
    [
        12448,
        12543
    ],
    [
        12544,
        12591
    ],
    [
        12592,
        12687
    ],
    [
        19968,
        20991
    ],
    [
        44032,
        45055
    ]
];
const $08a0126f35029825$var$operators = [
    '+',
    '-',
    '<',
    '>',
    '[',
    ']',
    '.',
    ','
];
const $08a0126f35029825$var$chars = $08a0126f35029825$var$charRange.flatMap(([start, end])=>Array.from({
        length: end - start + 1
    }, (_, i)=>String.fromCharCode(start + i)));
const $08a0126f35029825$var$combinations = [
    ...$08a0126f35029825$var$operators.flatMap((a)=>$08a0126f35029825$var$operators.map((b)=>a + b)),
    ...$08a0126f35029825$var$operators.flatMap((a)=>$08a0126f35029825$var$operators.flatMap((b)=>$08a0126f35029825$var$operators.map((c)=>a + b + c))),
    ...$08a0126f35029825$var$operators.flatMap((a)=>$08a0126f35029825$var$operators.flatMap((b)=>$08a0126f35029825$var$operators.flatMap((c)=>$08a0126f35029825$var$operators.map((d)=>a + b + c + d))))
];
if ($08a0126f35029825$var$combinations.length > $08a0126f35029825$var$chars.length) throw new Error('Not enough characters to encode all combinations');
const $08a0126f35029825$var$$ = Object.fromEntries($08a0126f35029825$var$combinations.map((combo, index)=>[
        combo,
        $08a0126f35029825$var$chars[index]
    ]));
const $08a0126f35029825$var$$$ = Object.fromEntries(Object.entries($08a0126f35029825$var$$).map(([k, v])=>[
        v,
        k
    ]));
// Base64url never contains '.', so this cannot collide with an existing compressed URL.
const $08a0126f35029825$var$correctionMarker = '.';
function $08a0126f35029825$var$toBase64Url(input) {
    const bytes = new TextEncoder().encode(input);
    let binary = '';
    for(let i = 0; i < bytes.length; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $08a0126f35029825$var$fromBase64Url(input) {
    const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char)=>char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}
function $08a0126f35029825$var$encodeRuns(input) {
    if (Array.from(input).some((char)=>!$08a0126f35029825$var$operators.includes(char))) return null;
    return input.replace(/(.)\1*/g, (run)=>run[0] + (run.length > 1 ? run.length.toString(36) : ''));
}
function $08a0126f35029825$var$decodeRuns(input) {
    if (!/^(?:[+\-<>\[\].,][0-9a-z]*)+$/.test(input)) throw new Error('Invalid run-length payload');
    return input.replace(/([+\-<>\[\].,])([0-9a-z]*)/g, (_, operator, encodedCount)=>{
        const count = encodedCount ? parseInt(encodedCount, 36) : 1;
        if (!Number.isSafeInteger(count) || count < 1) throw new Error('Invalid run-length payload');
        return operator.repeat(count);
    });
}
function $08a0126f35029825$export$80908c17a05abbe5(input, literalIndexes = []) {
    let result = '';
    let i = 0;
    while(i < input.length){
        let matched = false;
        for(let len = 4; len >= 2; len--)if (i + len - 1 < input.length) {
            const key = input.substring(i, i + len);
            if ($08a0126f35029825$var$$[key]) {
                result += $08a0126f35029825$var$$[key];
                i += len;
                matched = true;
                break;
            }
        }
        if (!matched) {
            if ($08a0126f35029825$var$$$[input[i]]) literalIndexes.push(result.length);
            result += input[i];
            i++;
        }
    }
    return result;
}
function $08a0126f35029825$export$678d868aab8fb3c7(input, literalIndexes = new Set()) {
    let result = '';
    for(let i = 0; i < input.length; i++){
        const char = input[i];
        let found = false;
        if (!literalIndexes.has(i) && $08a0126f35029825$var$$$[char]) {
            result += $08a0126f35029825$var$$$[char];
            found = true;
        }
        if (!found) result += char;
    }
    return result;
}
function $08a0126f35029825$export$8d0f35cd8ab2231e(input) {
    const literalIndexes = [];
    const compressed = $08a0126f35029825$export$80908c17a05abbe5(input, literalIndexes);
    let payload = $08a0126f35029825$var$toBase64Url(compressed);
    // Preserve the existing URL exactly unless compression loses information.
    if (literalIndexes.length > 0) payload += $08a0126f35029825$var$correctionMarker + literalIndexes.map((index)=>index.toString(36)).join('-');
    const runs = $08a0126f35029825$var$encodeRuns(input);
    const runPayload = runs === null ? null : $08a0126f35029825$var$correctionMarker + $08a0126f35029825$var$toBase64Url(runs);
    return runPayload !== null && runPayload.length < payload.length ? runPayload : payload;
}
function $08a0126f35029825$export$d269922819925891(input) {
    if (input.startsWith($08a0126f35029825$var$correctionMarker)) return $08a0126f35029825$var$decodeRuns($08a0126f35029825$var$fromBase64Url(input.substring($08a0126f35029825$var$correctionMarker.length)));
    const markerIndex = input.indexOf($08a0126f35029825$var$correctionMarker);
    if (markerIndex === -1) return $08a0126f35029825$export$678d868aab8fb3c7($08a0126f35029825$var$fromBase64Url(input));
    const corrections = input.substring(markerIndex + $08a0126f35029825$var$correctionMarker.length);
    if (!/^[0-9a-z]+(?:-[0-9a-z]+)*$/.test(corrections)) throw new Error('Invalid URL corrections');
    const literalIndexes = new Set(corrections.split('-').map((index)=>parseInt(index, 36)));
    return $08a0126f35029825$export$678d868aab8fb3c7($08a0126f35029825$var$fromBase64Url(input.substring(0, markerIndex)), literalIndexes);
}

});


var $1oFqu = parcelRequire("1oFqu");
const $d579707e50018af2$var$colorizeBF = (input)=>{
    return input.replaceAll(/(<)(?![a\/])/g, `&lt;`).replaceAll(/(?<!["a])(>)/g, `&gt;`).replaceAll(/((?:&lt;)+)/g, `<span operator="<">$1</span>`).replaceAll(/((?:&gt;)+)/g, `<span operator=">">$1</span>`).replaceAll(/(\++)/g, `<span operator="+">$1</span>`).replaceAll(/(-+)/g, `<span operator="-">$1</span>`).replaceAll(/(\.+)/g, `<span operator=".">$1</span>`).replaceAll(/(,+)/g, `<span operator=",">$1</span>`).replaceAll(/(\[)/g, `<span operator="[">$1</span>`).replaceAll(/(])/g, `<span operator="]">$1</span>`);
};
document.addEventListener("DOMContentLoaded", ()=>{
    const article = document.querySelector("article.learn");
    if (!article) return;
    // Colorize all code blocks
    article.querySelectorAll("pre > code").forEach((code)=>{
        code.innerHTML = $d579707e50018af2$var$colorizeBF(code.textContent ?? "");
    });
    // Wrap each <pre> with data-bf in a .code-block wrapper and add "Try it out" button
    article.querySelectorAll("pre[data-bf]").forEach((pre)=>{
        const bf = pre.getAttribute("data-bf");
        if (!bf) return;
        const wrapper = document.createElement("div");
        wrapper.className = "code-block";
        const link = document.createElement("a");
        link.className = "primary";
        link.href = `/#${(0, $1oFqu.encodeUrlPayload)(bf)}`;
        link.textContent = "Try it out \u2192";
        link.addEventListener("click", ()=>{
            const section = pre.closest("section")?.querySelector("h2, h3")?.textContent ?? "Unknown";
            plausible('Try It Out Clicked', {
                props: {
                    section: section
                }
            });
        });
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);
        wrapper.appendChild(link);
    });
    document.querySelector('footer a[href*="github.com"]')?.addEventListener('click', ()=>{
        plausible('Outbound Link: GitHub');
    });
});


//# sourceMappingURL=learn.135a8db3.js.map
